import React from 'react'
import Modal from 'react-modal'
import './ViewModalLogin.css'

const ViewModalLogin = ({ isOpen, onClose, children }) => (
  <Modal
    isOpen={isOpen}
    className="view-modal-login"
    overlayClassName="view-modal-overlay"
    onRequestClose={() => onClose()}>
    <div className="container">{children}</div>
  </Modal>
)

export default ViewModalLogin



// WEBPACK FOOTER //
// ./src/components/ViewModalLogin/index.js